import SeoLandingLayout from './components/SeoLandingLayout';

export default function AdelgazarPage() {
  return (
    <SeoLandingLayout
      title="Adelgazar en Palma de Mallorca con Nutricionista | Dario Rojas"
      description="Programa para adelgazar en Palma de Mallorca con Dario Rojas, nutricionista y dietista. Metodo sostenible sin dietas extremas."
      canonicalPath="/adelgazar-palma-de-mallorca"
      heading="Adelgazar en Palma de Mallorca con un plan sostenible"
      intro="Te ayudo a adelgazar de forma saludable, sin soluciones rapidas ni restricciones imposibles. El enfoque es perder grasa, mejorar habitos y mantener resultados."
      bullets={[
        'Estrategia nutricional adaptada a tu objetivo de peso',
        'Menus flexibles y buena alimentacion sin prohibiciones',
        'Control de hambre, ansiedad y adherencia',
        'Seguimiento para medir progreso real cada semana',
      ]}
      sections={[
        {
          title: 'Adelgazar sin dietas extremas',
          paragraphs: [
            'El objetivo no es solo bajar peso rapido, sino perder grasa de forma saludable y mantener resultados. Para eso definimos habitos sostenibles que se adapten a tu vida real.',
            'Trabajamos estructura de comidas, control de porciones, calidad nutricional y estrategias practicas para situaciones cotidianas como comer fuera o eventos sociales.',
          ],
        },
        {
          title: 'Seguimiento y ajustes personalizados',
          paragraphs: [
            'Cada persona responde distinto a un plan de alimentacion. Por eso revisamos progreso de forma periodica y ajustamos calorias, distribucion de macronutrientes y adherencia.',
            'Si tu objetivo es adelgazar en Palma con supervision profesional, te acompaño paso a paso para evitar estancamientos y mejorar composicion corporal.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'Cuanto peso se puede perder al mes de forma saludable?',
          answer:
            'Depende de cada caso, pero normalmente se busca una perdida progresiva y sostenible para proteger masa muscular y salud metabolica.',
        },
        {
          question: 'Tengo que eliminar carbohidratos para adelgazar?',
          answer:
            'No necesariamente. La clave es ajustar cantidades, calidad y distribucion segun tu objetivo y actividad.',
        },
        {
          question: 'Incluyes seguimiento para evitar rebote?',
          answer:
            'Si. El seguimiento esta enfocado en consolidar habitos para mantener resultados a largo plazo.',
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Programa para adelgazar en Palma de Mallorca',
        provider: {
          '@type': 'Person',
          name: 'Dario Rojas',
          jobTitle: 'Nutricionista y Dietista',
        },
        areaServed: 'Palma de Mallorca',
        serviceType: 'Adelgazamiento y educacion alimentaria',
        url: 'https://dariorojasnutricion.es/adelgazar-palma-de-mallorca',
        providerMobility: 'dynamic',
      }}
    />
  );
}
